export const reports = {
      title: 'Reports',
      subtitle: 'Review operational inventory reports',
      common: 'Common reports',
      commonDescription: 'Key reports for a manufacturing and distribution operation.',
      view: 'View report',
      comingSoon: 'Coming soon',
      run: 'Run report',
      kardexTitle: 'Product Kardex',
      kardexDescription: 'Chronological history of inbound, outbound, and balance per SKU.',
      kardexWorkspaceTitle: 'Kardex analyzer',
      kardexWorkspaceDescription: 'Select a product and optionally narrow the report by warehouse and date range.',
      backToReports: 'Back to reports',
      filtersTitle: 'Report filters',
      filtersDescription: 'Set the category, product, warehouse, and date range to review.',
      kardexResultTitle: 'Kardex result',
      kardexResultDescription: 'Review the chronological detail for the selected product.',
      exportCsv: 'Export CSV',
      exportPdf: 'Export PDF',
      kardexEmptyTitle: 'No Kardex movements found',
      kardexEmptyDescription: 'Select a product and run the report to review its movements.',
      selectProductPlaceholder: 'Select a product',
      allWarehouses: 'All warehouses',
      allDates: 'Full history',
      today: 'Today',
      startDate: 'Start date',
      endDate: 'End date',
      openingBalance: 'Opening balance',
      closingBalance: 'Closing balance',
      totalInbound: 'Inbound',
      totalOutbound: 'Outbound',
      totalInboundValue: 'Inbound value',
      totalOutboundValue: 'Outbound value',
      netMovement: 'Net movement',
      previousShort: 'Before',
      finalShort: 'Final',
      balanceBefore: 'Balance before',
      balanceAfter: 'Balance after',
      valuationTitle: 'Inventory valuation',
      valuationDescription: 'Total inventory value based on available stock and average cost.',
      valuationWorkspaceDescription: 'Review current inventory value by product and warehouse.',
      valuationResultTitle: 'Valuation result',
      valuationResultDescription: 'Current inventory detail valued using average cost.',
      allProducts: 'All products',
      totalInventoryValue: 'Total value',
      totalStock: 'Total stock',
      totalQuantity: 'Total quantity',
      totalProducts: 'Products',
      valuationEmptyTitle: 'No valuation records found',
      valuationEmptyDescription: 'Adjust the filters and run the report again to review valued inventory.',
      warehouseTitle: 'Inventory by warehouse',
      warehouseDescription: 'Summary of available stock grouped by warehouse.',
      warehouseWorkspaceDescription: 'Group current stock and value by warehouse.',
      warehouseResultTitle: 'Warehouse result',
      warehouseResultDescription: 'Review the consolidated warehouse summary for the applied filters.',
      warehouseCount: 'Warehouses',
      lowStockCount: 'Low',
      criticalStockCount: 'Critical',
      warehouseEmptyTitle: 'No warehouse records found',
      warehouseEmptyDescription: 'Adjust the filters and run the report again to review the consolidated summary.',
      lowStockTitle: 'Low stock products',
      lowStockDescription: 'Products below the defined minimum stock.',
      lowStockWorkspaceDescription: 'Detect critical or low products based on the configured minimum.',
      lowStockResultTitle: 'Low stock result',
      lowStockResultDescription: 'Review products that require attention by warehouse.',
      movementQuantity: 'Movement quantity',
      totalLowStockItems: 'Records',
      lowStockEmptyTitle: 'No products below minimum',
      lowStockEmptyDescription: 'No critical or low products were found for the applied filters.',
      movementsByTypeTitle: 'Movements by type',
      movementsByTypeDescription: 'Summary of movements grouped by type and direction for the selected period.',
      movementsByTypeWorkspaceDescription: 'Consolidate movements by type to review period volume and value.',
      movementsByTypeResultTitle: 'Result by type',
      movementsByTypeResultDescription: 'Review the summary grouped by movement type.',
      totalMovements: 'Movements',
      totalMovementGroups: 'Types',
      productionSalesTitle: 'Production vs sales outbound',
      productionSalesDescription: 'Compare recorded production against sales outbound movements for the period.',
      productionSalesWorkspaceDescription: 'Compare production and sales outbound inside the selected period.',
      productionSalesResultTitle: 'Production vs outbound result',
      productionSalesResultDescription: 'Review the daily comparison between production and sales outbound.',
      transfersTitle: 'Warehouse transfers',
      transfersDescription: 'Review transfer movements between source and destination warehouses.',
      transfersWorkspaceDescription: 'Review transfers recorded between warehouses for the period.',
      transfersResultTitle: 'Transfers result',
      transfersResultDescription: 'Review source-to-destination transfer detail.',
      warehousePairs: 'Pairs',
      clientOutboundTitle: 'Outbound by client',
      clientOutboundDescription: 'Detail of outbound movements associated with clients for operational follow-up.',
      clientOutboundWorkspaceDescription: 'Summarize outbound movements by client for commercial and operational follow-up.',
      clientOutboundResultTitle: 'Result by client',
      clientOutboundResultDescription: 'Review the outbound consolidation grouped by client.',
      totalClients: 'Clients',
    } as const;
